module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2021-09-22 at 8.57.25 PM.b87525bd.jpeg";